import React from 'react';
import EventDateViewer from './EventDateViewer';
import EventWinnerViewButton from './EventWinnerViewButton';
import EventMediaViewer from './EventMediaViewer';

const EventListItem = (props) => {
  const { postInfo } = props;
  return (
    <li>
      <div className="view-wrap">
        <div className="view-header">
          <a
            className="title"
            onClick={(e, postId) => props.onClickItem(e, postInfo.id)}
          >
            {postInfo.title}
          </a>
          <EventDateViewer postInfo={postInfo} />
          <EventWinnerViewButton {...props} />
        </div>
      </div>
      {postInfo.data && postInfo.data.event_info && (
        <div className="view-body">
          <figure>
            <EventMediaViewer
              postInfo={postInfo}
              onClickItem={props.onClickItem}
            />
          </figure>
        </div>
      )}
    </li>
  );
};

export default EventListItem;
